import React from 'react'
import Letsgo from '../connectors/letsgo'
import Protection from './protection'
import SectionSecurityAndManagement from './sectionSecurityAndManagement'
import "./securityAndManagement.scss"
import TeamUserSecurity from './teamUserSecurity'

function SecurityAndManagement() {
  return (
    <div className='container-security-and-management'>
        <div className='section-security-and-management'>
            <SectionSecurityAndManagement />
        </div>
        <div className='section-protection'>
          <Protection />
        </div>
        <div className='section-team-user-security'>
          <TeamUserSecurity />
        </div>

        <div className="section-lets-go">
          <Letsgo />
        </div>
    </div>
  )
}

export default SecurityAndManagement